import PROJECT_TYPES from 'common/constants/ProjectTypes.js'

export const isBlockArticleType = projectType => projectType === PROJECT_TYPES.blockArticle
